import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    fetchAllCompletedJobs,
    selectFetchingAllCompletedJobs,
    selectAllCompletedJobs
} from '../../../redux/actions/jobs';
import { JobForListType } from '../../../types';
import { Table } from '../../CommonComponents';
import { FetchPropsType } from '../../CommonComponents/Fetch/FetchPropsType';
import FetchRedux from '../../CommonComponents/Fetch/FetchRedux';
import { getOrderDate } from '../../../utils/order';
import { formatNumber } from '../../../utils/parsing';
import { getTenantLinkForJobsOffers } from '../../../utils/tenant-links';

const columns = [{
    name: 'Transportdatum',
    key: 'orderDate',
    getValue: getOrderDate
}, {
    name: 'Upphämtningsort',
    key: 'pickupCity'
}, {
    name: 'Leveransort',
    key: 'deliveryCity'
}, {
    name: 'Körsträcka',
    key: 'km',
    type: 'number' as 'number',
    getValue: (r: { drivingDistance: number }) => formatNumber(Math.round(r.drivingDistance / 1000), 'km')
}, {
    name: 'Totalvikt',
    key: 'grossWeight',
    type: 'kg' as 'kg'
}, {
    name: 'Uppdragsgivare',
    key: 'tenantId',
    getValue: getTenantLinkForJobsOffers
}];

function CompletedJobs(props: FetchPropsType<JobForListType[]>) {
    const { entity, isFetching } = props;
    const navigate = useNavigate();

    const onRowClick = React.useCallback(({ id }: { id: number | string }) => (
        navigate(`/jobs/${id}`)
    ), [navigate]);

    return (
        <Table
            name="offeredJobs"
            columns={columns}
            data={entity}
            onRowClick={onRowClick}
            emptyText={isFetching ? 'Hämtar utförda uppdrag...' : 'Ni har inga utförda uppdrag.'}
        />
    );
}

export default function CompletedJobsFetched() {
    return (
        <FetchRedux<JobForListType[]>
            fetchEntity={fetchAllCompletedJobs()}
            selectEntity={selectAllCompletedJobs()}
            selectIsFetching={selectFetchingAllCompletedJobs()}
            Component={CompletedJobs}
            name="bekräftade uppdragen"
        />
    );
}
